<template>    
    <v-tooltip top>
        <template  v-slot:activator="{ on }">
            <v-icon sm color="blue" v-on="on">mdi-help-circle-outline</v-icon>
        </template>
        <span>{{ hint }}</span>
    </v-tooltip>    
</template>

<script>
export default {
    name: 'HelperTooltip',
    inheritAttrs: false,    
    props: {
        hint: {
            type: String,
            default: ''
        }
    }
}
</script>

